import { useImagesStore } from '@/store/use-images-store';
import { pickFile } from '@/utils/fs/pick-file.utils';
import { SkuService } from '@/services/sku.service';

/**下载相应设备类型的预置表带*/
export const loadPresetSku = async (deviceType: string) => {
  let preset_sku = [];
  const service = new SkuService();
  preset_sku = await service.getSkuImages(deviceType);
  return preset_sku;
};

export const useWatchfaceSku = () => {
  const skuDir = '_sku';
  const imageStore = useImagesStore();

  const uploadSkuImage = async () => {
    const img = await pickFile({ extensions: ['jpg', 'png'] }).then(
      (r) => r?.[0]
    );
    if (!img) return;
    return await imageStore.uploadImage(img, {
      dirname: skuDir,
      md5: true
    });
  };

  const delSkuImage = async (skuName: string) => {
    imageStore.deleteImage(skuName);
    return skuName;
  };

  return {
    uploadSkuImage,
    delSkuImage,
    loadPresetSku
  };
};
